import { render, staticRenderFns } from "./officialAction.vue?vue&type=template&id=61999b1c&"
import script from "./officialAction.vue?vue&type=script&lang=js&"
export * from "./officialAction.vue?vue&type=script&lang=js&"
import style0 from "./officialAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports